import "../askgvt.css";
import { render } from "solid-js/web";
import { NewQuestionApp } from "./NewQuestionApp";

const mount = () => {
	render(() => <NewQuestionApp />, document.body);
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", mount);
} else {
	mount();
}
